import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		tooltip: {
			padding: 10
		},
		text: {
			color: theme.palette.common.white,
			fontSize: 16,
			textDecoration: "none",
			"&:hover": {
				textDecoration: "underline"
			}
		}
	} satisfies Record<string, CSSObject>;
};
